import React from 'react';
import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';

import * as S from './style';

const SubSkeleton02 = () => {
  const getItemRender = () => (
    <li className="item">
      <Skeleton className="thum" />
      <Skeleton className="text01" />
      <Skeleton className="text02" />
      <Skeleton className="text03" />
    </li>
  );

  return (
    <S.Box className="sub-skeleton-02">
      <ul className="list">
        {getItemRender()}
        {getItemRender()}
        {getItemRender()}
        {getItemRender()}
        {getItemRender()}
        {getItemRender()}
      </ul>
    </S.Box>
  );
};

export default SubSkeleton02;
